/*
 * SIM durum rozeti
 */

import { Badge } from "@chakra-ui/react";

const STATUS_MAP = {
  hazir: { label: "Hazır", color: "gray" },
  kullanımda: { label: "Kullanımda", color: "green" },
  kullanimda: { label: "Kullanımda", color: "green" },
  "bosa_cikan": { label: "Boşa Çıkan", color: "orange" },
};

export default function SimStatusBadge({ value }) {
  const key = value?.toLowerCase();
  const meta = STATUS_MAP[key] || { label: value || "-", color: "purple" };

  return (
    <Badge
      colorScheme={meta.color}
      variant="subtle"
      borderRadius="full"
      px={3}
      py={1}
      fontSize="0.75rem"
      textTransform="capitalize"
    >
      {meta.label}
    </Badge>
  );
}

